import { AnsibleBoolean } from './interfaces/ansible-config';

declare const __STANDARD_ACTION_FEEDBACK_DIALOG_ENABLED__: AnsibleBoolean;
declare const __ENABLE_VPC_PEERING_CONNECTIONS__: AnsibleBoolean;
declare const __H20_ENABLED_FEATURES__: {
  ALERTS: AnsibleBoolean;
  RBAC: AnsibleBoolean;
  BILLING: AnsibleBoolean;
  EDIT_SOURCE_DEST_NAME: AnsibleBoolean;
  EDIT_PIPELINE_CONFIG: AnsibleBoolean;
  ALLOW_COLUMN_LEVEL_CHANGES_ONLY: AnsibleBoolean;
  ACTION_FEEDBACK_DIALOG: AnsibleBoolean;
  COPY_STANDARD_DESTINATION: AnsibleBoolean;
  USE_CONNECTOR_BASED_APIS: AnsibleBoolean;
};

export enum SupportProvider {
  ZENDESK = 'ZENDESK',
  INTERCOM = 'INTERCOM'
}

declare const __SUPPORT_PROVIDER__: SupportProvider;
declare const __COMBINED_SUPPORT_OPTIONS__: AnsibleBoolean;
declare const __YOUTUBE_CONTENT_OWNER_REPORT_ENABLED__: AnsibleBoolean;
declare const __ENABLE_PIPELINE_CREATION_SUCCESS_EVENT_TO_ZAPIER__: AnsibleBoolean;
declare const __NEED_ATTENTION_ENABLED__: AnsibleBoolean;

export const EnvConfig = {
  getPipelineCreationSuccessEventToZapierEnabled() {
    return typeof __ENABLE_PIPELINE_CREATION_SUCCESS_EVENT_TO_ZAPIER__ !== 'undefined' && __ENABLE_PIPELINE_CREATION_SUCCESS_EVENT_TO_ZAPIER__ === AnsibleBoolean.TRUE;
  },

  getH20EnabledFeatures() {
    if (typeof __H20_ENABLED_FEATURES__ === 'undefined') {
      return {} as typeof __H20_ENABLED_FEATURES__;
    }

    return __H20_ENABLED_FEATURES__;
  },

  isH20FeatureEnabled(feature: keyof typeof __H20_ENABLED_FEATURES__) {
    return this.getH20EnabledFeatures()[feature] === AnsibleBoolean.TRUE;
  },

  getSupportProvider() {
    return typeof __SUPPORT_PROVIDER__ === 'undefined'
      ? SupportProvider.INTERCOM
      : __SUPPORT_PROVIDER__;
  },

  isCombinedSupportOptionsEnabled() {
    return typeof __COMBINED_SUPPORT_OPTIONS__ !== 'undefined' && __COMBINED_SUPPORT_OPTIONS__ === AnsibleBoolean.TRUE;
  },


  isEditPipelineConfigAllowed() {
    return EnvConfig.isH20FeatureEnabled('EDIT_PIPELINE_CONFIG');
  },

  isAllowColumnLevelChangesOnlyEnabled() {
    return EnvConfig.isH20FeatureEnabled('ALLOW_COLUMN_LEVEL_CHANGES_ONLY');
  },


  get isCopyStandardDestinationEnabled() {
    return EnvConfig.isH20FeatureEnabled('COPY_STANDARD_DESTINATION');
  },

  get isEdgeActionFeedbackDialogEnabled() {
    return EnvConfig.isH20FeatureEnabled('ACTION_FEEDBACK_DIALOG');
  },

  get isStandardActionFeedbackDialogEnabled() {
    return typeof __STANDARD_ACTION_FEEDBACK_DIALOG_ENABLED__ !== 'undefined' && __STANDARD_ACTION_FEEDBACK_DIALOG_ENABLED__ === AnsibleBoolean.TRUE;
  },

  get isUseConnectorBasedAPIsEnabled() {
    return EnvConfig.isH20FeatureEnabled('USE_CONNECTOR_BASED_APIS');
  },

  get isVpcPeeringConnectionEnabled() {
    return typeof __ENABLE_VPC_PEERING_CONNECTIONS__ !== 'undefined' && __ENABLE_VPC_PEERING_CONNECTIONS__ === AnsibleBoolean.TRUE
  },

  get isNeedAttentionEnabled() {
    return typeof __NEED_ATTENTION_ENABLED__ !== 'undefined' && __NEED_ATTENTION_ENABLED__ === AnsibleBoolean.TRUE
  }
};
